module.exports = "/images/side-site-design-active.svg?5a615b2e0cda20aa509d45cbf61e0aa0";